import { render, staticRenderFns } from "./svgcomponent.vue?vue&type=template&id=327b59c9&"
import script from "./svgcomponent.vue?vue&type=script&lang=js&"
export * from "./svgcomponent.vue?vue&type=script&lang=js&"
import style0 from "./svgcomponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports